module.exports = __webpack_public_path__ + "c76b96584dfcfec6ce97a7d22d816929.png";